var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-menu-layout',{attrs:{"nav-items":_vm.navItems,"select-label":_vm.activeMenu,"header-title":"","parent-label":_vm.parentLabel,"parent-link":_vm.parentLink}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }